import axios from '@/axios';

export const AlimtalkApi = {
    getTokenList: async () => {
        const response = await axios.get('/bizmsg/tokens');
        return response.data;
    },
    
    refreshToken: async () => {
        const response = await axios.put('/bizmsg/refresh/tokens');
        return response.data;
    },

    // 알림톡 템플릿 목록 조회 (환경 변수 중 KAKAO_TEMPLATE 타입만 조회)
    getTemplateList: async (params) => {
        // 항상 KAKAO_TEMPLATE 타입만 조회하도록 설정
        const queryParams = {
            ...params,
            envType: 'KAKAO_TEMPLATE'
        };
        
        const response = await axios.get('/env-configs', { params: queryParams });
        return response.data;
    },
    
    // 템플릿 상세 조회
    getTemplate: async (configKey) => {
        const response = await axios.get(`/env-configs/${configKey}`);
        return response.data;
    },
    
    // 템플릿 등록
    createTemplate: async (templateData) => {
        // 항상 KAKAO_TEMPLATE 타입으로 설정
        const data = {
            ...templateData,
            envType: 'KAKAO_TEMPLATE'
        };
        
        const response = await axios.post('/env-configs', data);
        return response.data;
    },
    
    // 템플릿 수정
    updateTemplate: async (configKey, templateData) => {
        // 항상 KAKAO_TEMPLATE 타입으로 설정
        const data = {
            ...templateData,
            envType: 'KAKAO_TEMPLATE'
        };
        
        const response = await axios.put(`/env-configs/${configKey}`, data);
        return response.data;
    },
    
    // 템플릿 삭제
    deleteTemplate: async (configKey) => {
        const response = await axios.delete(`/env-configs/${configKey}`);
        return response.data;
    }
}

// BizmsgApi
export const BizmsgApi = {
  /**
   * Resell 템플릿 목록 조회
   * @param {Object} params - 검색 파라미터
   * @param {string} [params.startDate] - 시작 날짜
   * @param {string} [params.kepStatus] - 템플릿 상태
   * @param {number} [params.page] - 페이지 번호
   * @param {number} [params.rows] - 페이지 크기
   * @returns {Promise}
   */
  getAlimtalkResellTemplates: async (params = {}) => {
    console.log("템플릿 목록 조회 요청:", { params });
    return await axios.get('/bizmsg/resell/templates', { params });
  },

  /**
   * Resell 템플릿 상세 조회
   * @param {string} templateCode - 템플릿 코드
   * @returns {Promise}
   */
  getAlimtalkResellTemplate: async (templateCode) => {
    console.log("템플릿 상세 조회 요청:", { templateCode });
    return await axios.get(`/bizmsg/resell/templates/${templateCode}`);
  },
  
  /**
   * 카카오 알림톡 발송 테스트
   * @param {Object} messageData - 발송할 메시지 데이터
   * @returns {Promise}
   */
  sendKakaoMessage: async (messageData) => {
    console.log("알림톡 테스트 발송 요청:", { messageData });
    return await axios.post('/bizmsg/send/kakao', messageData);
  }
};

// KakaocloudApi
export const KakaocloudApi = {
    /**
     * 카카오클라우드 토큰 목록 조회
     * @returns {Promise}
     */
    getTokenList: async () => {
        console.log("카카오클라우드 토큰 목록 조회 요청");
        const response = await axios.get('/kakaocloud/auth/tokens');
        console.log("카카오클라우드 토큰 응답 원본:", response);

        // axios는 응답을 data 필드에 담아서 반환합니다
        return response.data;
    },

    /**
     * 카카오클라우드 토큰 갱신
     * @returns {Promise}
     */
    refreshToken: async () => {
        console.log("카카오클라우드 토큰 갱신 요청");
        const response = await axios.put('/kakaocloud/auth/refresh/tokens');
        return response.data;
    }
};

// BizmsgAuthApi - 비즈메시지 인증 관리 API (실제 API)
export const BizmsgAuthApi = {
    /**
     * 전체 비즈메시지 인증 정보 조회
     * @returns {Promise<Array>}
     */
    getAllBizmsgAuth: async () => {
        console.log("전체 비즈메시지 인증 정보 조회 요청");
        const response = await axios.get('/bizmsg/auth');
        return response.data;
    },

    /**
     * 특정 회사의 비즈메시지 인증 정보 조회
     * @param {string} companyId - 회사 ID
     * @returns {Promise<Object>}
     */
    getBizmsgAuthByCompanyId: async (companyId) => {
        console.log("비즈메시지 인증 정보 조회 요청:", { companyId });
        const response = await axios.get(`/bizmsg/auth/${companyId}`);
        return response.data;
    },

    /**
     * 비즈메시지 인증 정보 생성
     * @param {Object} authData - 인증 데이터 (companyId, companyName, channels 포함)
     * @returns {Promise<Object>}
     */
    createBizmsgAuth: async (authData) => {
        console.log("비즈메시지 인증 정보 생성 요청:", { authData });
        const response = await axios.post('/bizmsg/auth', authData);
        return response.data;
    },

    /**
     * 비즈메시지 인증 정보 수정
     * @param {string} companyId - 회사 ID
     * @param {Object} authData - 수정할 인증 데이터
     * @returns {Promise<Object>}
     */
    updateBizmsgAuth: async (companyId, authData) => {
        console.log("비즈메시지 인증 정보 수정 요청:", { companyId, authData });
        const response = await axios.put(`/bizmsg/auth/${companyId}`, authData);
        return response.data;
    },

    /**
     * 비즈메시지 인증 정보 삭제
     * @param {string} companyId - 회사 ID
     * @returns {Promise<Object>}
     */
    deleteBizmsgAuth: async (companyId) => {
        console.log("비즈메시지 인증 정보 삭제 요청:", { companyId });
        const response = await axios.delete(`/bizmsg/auth/${companyId}`);
        return response.data;
    },

    /**
     * 채널 추가
     * @param {string} companyId - 회사 ID
     * @param {Object} channelData - 채널 데이터
     * @returns {Promise<Object>}
     */
    createChannel: async (companyId, channelData) => {
        console.log("채널 추가 요청:", { companyId, channelData });
        const response = await axios.post(`/bizmsg/auth/${companyId}/channels`, channelData);
        return response.data;
    },

    /**
     * 채널 수정
     * @param {string} companyId - 회사 ID
     * @param {string} channelId - 채널 ID
     * @param {Object} channelData - 채널 데이터
     * @returns {Promise<Object>}
     */
    updateChannel: async (companyId, channelId, channelData) => {
        console.log("채널 수정 요청:", { companyId, channelId, channelData });
        const response = await axios.put(`/bizmsg/auth/${companyId}/channels/${channelId}`, channelData);
        return response.data;
    },

    /**
     * 채널 삭제
     * @param {string} companyId - 회사 ID
     * @param {string} channelId - 채널 ID
     * @returns {Promise<Object>}
     */
    deleteChannel: async (companyId, channelId) => {
        console.log("채널 삭제 요청:", { companyId, channelId });
        const response = await axios.delete(`/bizmsg/auth/${companyId}/channels/${channelId}`);
        return response.data;
    }
};

// ChannelTokenApi - 채널별 토큰관리 API (인터페이스 전용 - 실제 API는 BizmsgAuthApi 사용)
export const ChannelTokenApi = {
    /**
     * 채널별 토큰 정보 조회 (전체 목록의 첫 번째 항목 반환)
     * @returns {Promise}
     */
    getChannelTokenInfo: async () => {
        console.log("채널별 토큰 정보 조회 요청");
        try {
            const authList = await BizmsgAuthApi.getAllBizmsgAuth();

            // 배열인 경우 첫 번째 항목 반환
            if (Array.isArray(authList) && authList.length > 0) {
                return { success: true, data: authList[0] };
            }

            return { success: false, message: '토큰 정보를 찾을 수 없습니다.' };
        } catch (error) {
            console.error('토큰 정보 조회 오류:', error);
            return { success: false, message: error.message };
        }
    },

    /**
     * 특정 회사의 채널별 토큰 정보 조회
     * @param {string} companyId - 회사 ID
     * @returns {Promise}
     */
    getChannelTokenInfoByCompanyId: async (companyId) => {
        console.log("특정 회사 토큰 정보 조회 요청:", { companyId });
        try {
            const authInfo = await BizmsgAuthApi.getBizmsgAuthByCompanyId(companyId);
            return { success: true, data: authInfo };
        } catch (error) {
            console.error('토큰 정보 조회 오류:', error);
            return { success: false, message: error.message };
        }
    },

    /**
     * 채널 추가
     * @param {Object} channelData - 채널 데이터
     * @returns {Promise}
     */
    createChannel: async (channelData) => {
        console.log("채널 추가 요청:", channelData);
        // TODO: API 구현 필요
        return { success: true, message: '채널 추가 기능은 개발 중입니다.' };
    },

    /**
     * 채널 수정
     * @param {string} channelId - 채널 ID
     * @param {Object} channelData - 채널 데이터
     * @returns {Promise}
     */
    updateChannel: async (channelId, channelData) => {
        console.log("채널 수정 요청:", { channelId, channelData });
        // TODO: API 구현 필요
        return { success: true, message: '채널 수정 기능은 개발 중입니다.' };
    },

    /**
     * 채널 삭제
     * @param {string} channelId - 채널 ID
     * @returns {Promise}
     */
    deleteChannel: async (channelId) => {
        console.log("채널 삭제 요청:", { channelId });
        // TODO: API 구현 필요
        return { success: true, message: '채널 삭제 기능은 개발 중입니다.' };
    },

    /**
     * 채널 토큰 갱신
     * @param {string} channelId - 채널 ID
     * @returns {Promise}
     */
    refreshChannelToken: async (channelId) => {
        console.log("채널 토큰 갱신 요청:", { channelId });
        // TODO: API 구현 필요
        return { success: true, message: '채널 토큰 갱신 기능은 개발 중입니다.' };
    },

    /**
     * 전체 토큰 갱신
     * @returns {Promise}
     */
    refreshAllTokens: async () => {
        console.log("전체 토큰 갱신 요청");
        // TODO: API 구현 필요
        return { success: true, message: '전체 토큰 갱신 기능은 개발 중입니다.' };
    }
};
